var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{staticClass:"block",attrs:{"position":_vm.data.Position || 'is-centered'},on:{"input":_vm.onClick}},[_vm._l((_vm.data.Data),function(tab,n){return [_c('b-tab-item',{key:n,attrs:{"value":n.toString(),"label":tab.Name}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }